import { render, staticRenderFns } from "./ListPublications.vue?vue&type=template&id=a36d01bc&scoped=true&"
import script from "./ListPublications.vue?vue&type=script&lang=js&"
export * from "./ListPublications.vue?vue&type=script&lang=js&"
import style0 from "./ListPublications.vue?vue&type=style&index=0&id=a36d01bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36d01bc",
  null
  
)

export default component.exports